import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter} from '@angular/material/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {MemberService} from '../../../services/member.service';
import {AuthService} from '../../../services/auth.service';
import {Member} from '../../../models/member';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {Document} from 'src/app/models/document';
import {AgendaService} from 'src/app/services/agenda.service';
import {OrderedService} from 'src/app/services/ordered.service';
import {Subcategory} from 'src/app/models/subcategory';
import {SubcategoryService} from 'src/app/services/subcategory.service';
import {MemberDocumentDialogComponent} from '../member-document-dialog/member-document-dialog.component';
import {EnrollmentService} from 'src/app/services/enrollment.service';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Annotation} from 'src/app/models/annotatios';
import {MemberAnnotationDialogComponent} from '../member-annotation-dialog/member-annotation-dialog.component';
import {AnnotationService} from 'src/app/services/annotation.service';
import {CepService} from 'src/app/services/cep.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {FolderService} from 'src/app/services/folder.service';
import {SubcategoryHistoryService} from 'src/app/services/subcategory-history.service';
import {SubcategoryHistory} from 'src/app/models/subcategory-history';
import {MemberSubcategoryDialogComponent} from '../member-subcategory-dialog/member-subcategory-dialog.component';
import {RegionalService} from 'src/app/services/regional.service';
import {MemberLinksService} from 'src/app/services/member-links.service';
import {MemberLink} from 'src/app/models/member-link';
import {MemberLinksDialogComponent} from '../member-links-dialog/member-links-dialog.component';
import {MemberTpiccvData} from 'src/app/models/member-tpiccv-data';
import {MemberTpiccvDialogComponent} from '../member-tpiccv-dialog/member-tpiccv-dialog.component';
import {MemberTpiccvService} from 'src/app/services/member-tpiccv.service';
import {MemberBackgroundService} from 'src/app/services/member-background.service';
import {MemberBackgroundData} from 'src/app/models/member-background-data';
import {MemberBackgroundDialogComponent} from '../member-background-dialog/member-background-dialog.component';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {DocumentService} from 'src/app/services/document.service';
import {MatTableDataSource} from '@angular/material/table';
import {take} from 'rxjs/operators';
import {MemberPaymentDialogComponent} from '../member-payment-dialog/member-payment-dialog.component';
import {Ordered} from 'src/app/models/ordered';
import {MemberEditPaymentDialogComponent} from '../member-edit-payment-dialog/member-edit-payment-dialog.component';
import {CalableMemberService} from 'src/app/services/calable-member.service';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {ConfigService} from 'src/app/services/config.service';
import {EmailService} from 'src/app/services/email.service';
import {MemberOrderDateDialogComponent} from '../member-order-date-dialog/member-order-date-dialog.component';
import {AnnuityService} from 'src/app/services/annuity.service';
import {ContriesService} from 'src/app/services/countries.service';
import {Subscription} from 'rxjs';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-dialog',
  templateUrl: './member-dialog.component.html',
  styleUrls: [ './member-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: []
})
export class MemberDialogComponent implements OnInit {

  public waiting: any = {}

  public matcher = new FormErrorStateMatcher();
  public memberForm: FormGroup;
  public isEdit: boolean;
  public local_title: any;

  public partnerText: string;

  public situations: any[] = [ {name: "Quite", value: "0"}, {name: "Não-Quite", value: "1"}, {name: "Isento", value: "2"} ];

  public oldCategory: any = {};
  public subCategories: any[] = [];
  public regionals: any[] = [];

  public subCategorySelected_id: string;
  public subCategorySelected: Subcategory;

  public memberAnnotations$: any;
  public displayedAnnotationColumns: string[] = [ 'date', 'text', 'status', 'edit', 'delete' ];

  public memberLinks$: any;
  public displayedMemberLinkColumns: string[] = [ 'date', 'text', 'link', 'edit', 'delete' ];

  public memberTpiccv$: any;
  public displayedMemberTpiccvColumns: string[] = [ 'date', 'text', 'edit', 'delete' ];

  public memberBackgrounds$: any;
  public displayedMemberBackgroundColumns: string[] = [ 'dateStart', 'dateEnd', 'text', 'location', 'edit', 'delete' ];

  public memberSubCategoryHistory$: any;
  public displayedSubcategoryHistoryColumns: string[] = [ 'date', 'subcategory', 'payannuity', 'edit', 'delete' ];

  public displayedDocumentColumns: string[] = [ 'icon', 'date', 'filename', 'vaccinated', 'approved', 'edit', 'delete' ];

  public annuitesDataSource: MatTableDataSource<any>
  public displayedAnnuitesColumns: string[] = [ 'annuity', 'date', 'category', 'origin', 'type', 'value', 'total', 'edit' ];

  public displayedOrdersByMembrColumns: string[] = [ 'name' ];

  public enrolmentDataSource: MatTableDataSource<any>
  public displayedEnrolmentColumns: string[] = [ 'event', 'request', "delete" ];


  public isAnnuityFree: boolean = false
  public totalDebit: number = 0;
  public totalPlots: number = 0;
  public nextAnnuity: any = null;
  public calcFinish: boolean = false;

  public Editor = ClassicEditor;

  public countries: any[] = [];
  private sub: Subscription;

  constructor (
    private fb: FormBuilder,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private db: AngularFirestore,
    private dialog: MatDialog,
    public _memberService: MemberService,
    public _folderService: FolderService,
    public _regionalService: RegionalService,
    public _subcategoryService: SubcategoryService,
    public _agendaService: AgendaService,
    public _orderedService: OrderedService,
    public _enrolmentService: EnrollmentService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private _annotationService: AnnotationService,
    private _memberLinksService: MemberLinksService,
    private _subcategoryHistoryService: SubcategoryHistoryService,
    private _cepService: CepService,
    private _spinnerService: SpinnerService,
    public _memberTpiccvService: MemberTpiccvService,
    public _memberBackgroundService: MemberBackgroundService,
    public _documentService: DocumentService,
    private _calableMemberService: CalableMemberService,
    private _configService: ConfigService,
    private _emailService: EmailService,
    public _annuityService: AnnuityService,
    private _countriesService: ContriesService,
    @Inject(MAT_DIALOG_DATA) public data: Member
  ) {
    // this.categories = this.this.categories ();
  }

  ngOnInit () {

    this._adapter.setLocale('pt');
    this._memberService.storedImage = null;

    // create user form
    this.memberForm = this.createForm()

    this._subcategoryService.loadAll().subscribe((result) => {
      this.subCategories = result;
    });

    this._regionalService.load().subscribe((result) => {
      this.regionals = result;
    })

    // check is is insert or update
    this.isEdit = this.data.id != "0"

    this.initForm();

  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  initForm () {
    this.loadCountries();

    if (this.isEdit) {

      this.local_title = this.data.name
      // populate the form
      this.setFormValues(this.data, this.memberForm)

      this.memberAnnotations$ = this._annotationService.selectByMemberId(this.data.id);
      this.memberLinks$ = this._memberLinksService.selectByMemberId(this.data.id);
      this.memberTpiccv$ = this._memberTpiccvService.selectByMemberId(this.data.id);
      this.memberBackgrounds$ = this._memberBackgroundService.selectByMemberId(this.data.id);
      this.memberSubCategoryHistory$ = this._subcategoryHistoryService.selectByMemberId(this.data.id);

      this.loadFolders()
      this.getMemberAllAnnuitiesAdmin(this.data.id)
      this._orderedService.loadProducts()
      this._orderedService.getOrdersByMemberId(this.data.id)
      this.loadEnrollments()
      this._agendaService.getAgendaByMember(this.data.id)

      this.checkNextAnnuity(this.data.id);

    } else {
      this.local_title = "Associado"
    }
  }

  loadCountries () {
    this.sub = this._countriesService.select().subscribe({
      next: countries => {
        this.countries = countries;
        // console.log("this.countries: " + JSON.stringify(this.countries));
      },
      error: err => console.log("erro ao ler countries: " + err.message)
    });
  }


  onSubCategoryChange (event) {
    this.subCategorySelected_id = event;
    this.subCategorySelected = this.subCategories.find((e) => {
      return e.id == this.subCategorySelected_id
    })

    if (this.subCategorySelected.partner) {
      this.partnerText = "Sócio"
    } else {
      this.partnerText = "Não Sócio"
    }
    console.log("this.subCategorySelected: " + JSON.stringify(this.subCategorySelected))
  }

  async insert () {
    if (!this.memberForm.valid) return;

    const waiting = this._spinnerService.show();

    try {
      const memberData = this.memberForm.getRawValue();
      const member = await this.createMember(memberData);

      // Aguarda o update do Firestore
      await this._memberService.insert(member)
        .then((result) => {
          console.log("result.id:  " + result.id)
          this.isEdit = true;
          this.data = member;
          this.data.id = result.id
          this.memberForm.controls.id.setValue(this.data.id);
          //console.log(JSON.stringify(this.data))
        })
        .catch((err: any) => {
          console.log("erro: " + err.message)
        })

      // Operações paralelas ou sequenciais após sucesso
      if (this._memberService.objectImage) {
        this._memberService.uploadImage(this._memberService.objectImage, this.data.id, this.memberForm);
      }

      if (member.staff) {
        this.updateStaff(member);
      }

      this.snackBar.openSnackBar('Atualizado com sucesso!', '', 'success');

    } catch (error) {
      console.error("member update error:", error);
      const msgError = this._memberService.makeMsgError(error?.details?.code);
      this.snackBar.openSnackBar(msgError, '', 'error');
    } finally {
      waiting.close();
    }
  }

  async update () {
    if (!this.memberForm.valid) return;

    const waiting = this._spinnerService.show();

    try {
      const memberData = this.memberForm.getRawValue();
      const member = await this.createMember(memberData);

      // console.log("update: " +  JSON.stringify(member));
      await this._memberService.update(member);

      // Operações paralelas ou sequenciais após sucesso
      if (this._memberService.objectImage) {
        this._memberService.uploadImage(this._memberService.objectImage, this.data.id, this.memberForm);
      }

      //if (member.staff) {
      // this.updateStaff(member);
      //  executanmdo em funcions onUpdatemember
      //}

      this.snackBar.openSnackBar('Atualizado com sucesso!', '', 'success');

    } catch (error) {
      console.error("member update error:", error);
      const msgError = this._memberService.makeMsgError(error?.details?.code);
      this.snackBar.openSnackBar(msgError, '', 'error');
    } finally {
      waiting.close();
    }

  }

  deleteMember () {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: this.data.name + "<br><br>Excluir este associado?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._memberService.delete(this.data.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete member error: " + error.message)}
          )
      }
    })
  }

  updateStaff (member: any) {
    this._memberService.updateSpeaker({
      'id': member.id,
      'name': member.name,
      'image': member.image ? member.image : "",
      'text': member.text ? member.text : ""
    })
      .then(() => {console.log('ok')})
      .catch((err) => {console.log('erro')})
  }

  async _createMember (data: any): Promise<Member> {

    const currentUser = await this._authService.getCurrentUser();

    // 1. Tratamento de CPF ultra-eficiente com Regex
    const cleanCpf = data.cpf ? data.cpf.replace(/[.;\-: ]/g, '') : '';

    // 2. Composição de objeto (Pegamos tudo que vem do form e sobrescrevemos o necessário)
    const entity: Member = {
      ...data,
      cpf: cleanCpf,
      balance: data.balance ?? 0,
      credit: data.credit ?? 0,
      annuity_from: data.annuity_from ?? 0,
      subCategory: data.subCategory || {...this.subCategorySelected},
      updateBy: currentUser?.email || 'system',
      gn1: false
    };

    // 3. Limpeza de campos nulos/undefined (evita lixo no Firestore)
    const fieldsToClean = [ 'created', 'dateFiliation', 'dateTitle', 'dateBirth', 'resident_begin', 'resident_end', 'push' ];
    fieldsToClean.forEach(field => {
      if (!entity[ field ]) delete entity[ field ];
    });

    return entity;
  }

  async createMember (data: any): Promise<Member> {
    const currentUser = await this._authService.getCurrentUser();

    const cleanCpf = data.cpf ? data.cpf.replace(/[.;\-: ]/g, '') : '';

    // 1. Criamos a base da entidade
    const entity: Member = {
      ...data,
      cpf: cleanCpf,
      balance: data.balance ?? 0,
      credit: data.credit ?? 0,
      annuity_from: data.annuity_from ?? 0,
      subCategory: data.subCategory || {...this.subCategorySelected},
      updateBy: currentUser?.email || 'system',
      gn1: data.gn1 || false
    };

    // 2. Tratamento rigoroso de DATAS
    const dateFields = [ 'dateBirth', 'dateFiliation', 'dateTitle', 'resident_begin', 'resident_end', 'created' ];

    dateFields.forEach(field => {
      const value = entity[ field ];

      if (!value) {
        // Se estiver vazio (null, undefined, ""), removemos para não dar erro no Firestore
        delete entity[ field ];
      } else {
        // Tenta converter para Date (caso seja string)
        const dateObj = new Date(value);

        // Verifica se a data é válida
        if (isNaN(dateObj.getTime())) {
          console.warn(`Campo ${ field } contém data inválida:`, value);
          delete entity[ field ]; // Remove se for inválida
        } else {
          entity[ field ] = dateObj; // Garante que é um objeto Date
        }
      }
    });

    return entity;
  }

  setFormValues (data, form) {

    form.controls.created.setValue(data.created);
    form.controls.dateBirth.setValue(data.dateBirth);
    form.controls.dateFiliation.setValue(data.dateFiliation);
    form.controls.dateTitle.setValue(data.dateTitle);

    form.controls.id.setValue(data.id);
    form.controls.category.setValue(data.category ? data.category : "");

    if (data.subCategory) {
      this.subCategorySelected = data.subCategory
      this.subCategorySelected_id = data.subCategory.id
      if (data.subCategory.partner) {
        this.partnerText = "Sócio"
      } else {
        this.partnerText = "Não Sócio"
      }
    }

    form.controls.name.setValue(data.name ? data.name : "");
    form.controls.shortName.setValue(data.shortName ? data.shortName : "");

    form.controls.situation.setValue(data.situation ? data.situation : "");
    form.controls.balance.setValue(data.balance ? data.balance : 0);

    form.controls.credit.setValue(data.credit ? data.credit : 0);

    form.controls.annuity_from.setValue(data.annuity_from ? data.annuity_from : 0);

    form.controls.address.setValue(data.address ? data.address : "");
    form.controls.district.setValue(data.district ? data.district : "");
    form.controls.number.setValue(data.number ? data.number : "");
    form.controls.complement.setValue(data.complement ? data.complement : "");
    form.controls.postalCode.setValue(data.postalCode ? data.postalCode : "");

    form.controls.city.setValue(data.city ? data.city : "");
    form.controls.state.setValue(data.state ? data.state : "");
    form.controls.country.setValue(data.country ? data.country : "");

    form.controls.foreignCustomer.setValue(data.foreignCustomer ? data.foreignCustomer : false);

    form.controls.email.setValue(data.email ? data.email : "");

    form.controls.email2.setValue(data.email2 ? data.email2 : "");
    form.controls.cellPhone.setValue(data.cellPhone ? data.cellPhone : "");
    form.controls.cellPhonePrefix.setValue(data.cellPhonePrefix ? data.cellPhonePrefix : "+55");
    form.controls.faxPhone.setValue(data.faxPhone ? data.faxPhone : "");

    form.controls.image.setValue(data.image ? data.image : "");
    form.controls.text.setValue(data.text ? data.text : "");

    if (data.faxPhone && data.faxPhone.length > 10) {
      //    this.maskPhone = '(00) 0000-0000'
    } else {
      //   this.maskPhone = '(00) 00000-0000'
    }

    form.controls.clinicPhone.setValue(data.clinicPhone ? data.clinicPhone : "");
    form.controls.hospitalPhone.setValue(data.hospitalPhone ? data.hospitalPhone : "");
    form.controls.aux1Phone.setValue(data.aux1Phone ? data.aux1Phone : "");
    form.controls.aux2Phone.setValue(data.aux2Phone ? data.aux2Phone : "");

    form.controls.rg.setValue(data.rg ? data.rg : "");

    form.controls.cpf.setValue(data.cpf ? data.cpf : "");
    form.controls.crm.setValue(data.crm ? data.crm : "");
    form.controls.rqe.setValue(data.rqe ? data.rqe : "");
    form.controls.crmUF.setValue(data.crmUF ? data.crmUF : "");
    form.controls.regional.setValue(data.regional ? data.regional : "");
    form.controls.sex.setValue(data.sex ? data.sex : "");

    form.controls.obs.setValue(data.obs ? data.obs : "");
    form.controls.note.setValue(data.note ? data.note : "");
    form.controls.gn1.setValue(data.gn1);

    form.controls.staff.setValue(data.staff ? data.staff : false);
    form.controls.title.setValue(data.title ? data.title : "");
    form.controls.tester.setValue(data.tester ? data.tester : false);
    form.controls.zzversion.setValue(data.zzversion ? data.zzversion : "0");

    form.controls.proofOfVaccine.setValue(data.proofOfVaccine ? data.proofOfVaccine : false);

    form.controls.resident_institute.setValue(data.resident_institute ? data.resident_institute : "");

    form.controls.linkCurriculum.setValue(data.linkCurriculum ? data.linkCurriculum : "");

    let dtBegin
    if (data.resident_begin) {
      dtBegin = new Date(data.resident_begin.seconds * 1000)
    }
    form.controls.resident_begin.setValue(dtBegin);

    let dtEnd
    if (data.resident_end) {
      dtEnd = new Date(data.resident_end.seconds * 1000)
    }
    form.controls.resident_end.setValue(dtEnd);

    // console.log("data.image: " + data.image )

    this._memberService.storedImage = data.image;
  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      category: new FormControl(''),
      situation: new FormControl('', [ Validators.required ]),
      balance: new FormControl(''),
      credit: new FormControl(''),
      annuity_from: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      shortName: new FormControl(''),
      image: new FormControl(''),
      text: new FormControl(''),
      text_html: new FormControl(''),
      address: new FormControl(''),
      number: new FormControl(''),
      district: new FormControl(''),
      complement: new FormControl(''),
      postalCode: new FormControl(''),
      foreignCustomer: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      country: new FormControl(''),
      email: new FormControl('', [ Validators.required, Validators.email ]),
      email2: new FormControl(''),
      cellPhonePrefix: new FormControl(''),
      cellPhone: new FormControl('', [ Validators.required ]),
      faxPhone: new FormControl(''),
      clinicPhone: new FormControl(''),
      hospitalPhone: new FormControl(''),
      aux1Phone: new FormControl(''),
      aux2Phone: new FormControl(''),
      rg: new FormControl(''),
      cpf: new FormControl(''),
      crm: new FormControl(''),
      rqe: new FormControl(''),
      crmUF: new FormControl(''),
      dateBirth: new FormControl(''),
      dateFiliation: new FormControl(''),
      dateTitle: new FormControl(''),
      created: new FormControl(''),
      regional: new FormControl(''),
      sex: new FormControl(''),

      obs: new FormControl(''),
      note: new FormControl(''),
      linkCurriculum: new FormControl(''),

      staff: new FormControl(''),
      tester: new FormControl(''),
      zzversion: new FormControl(''),
      title: new FormControl(''),

      resident_institute: new FormControl(''),
      resident_begin: new FormControl(''),
      resident_end: new FormControl(''),

      proofOfVaccine: new FormControl(''),
      gn1: new FormControl('')

    });
    return form;

  }

  openAnnotationDialog (entity) {

    let data: Annotation = new Annotation();

    if (entity) {
      data = entity;
    }

    data.member_id = this.data.id
    data.member_name = this.data.name

    let dialogRef = this.dialog.open(MemberAnnotationDialogComponent, {
      width: '600px',
      height: '470px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];

      const data = this._annotationService.createAnnotation(formData.getRawValue())

      if (action === "add") {
        this._annotationService.insert(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      } else if (action === "edit") {
        this._annotationService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      }

    })

  }

  openMemberLinksDialog (entity) {

    let data: MemberLink = new MemberLink();

    if (entity) {
      data = entity;
    }

    data.member_id = this.data.id
    data.member_name = this.data.name

    let dialogRef = this.dialog.open(MemberLinksDialogComponent, {
      width: '600px',
      height: '470px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];

      const data = this._memberLinksService.createLink(formData.getRawValue())
      console.log(JSON.stringify(data))

      if (action === "add") {
        this._memberLinksService.insert(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      } else if (action === "edit") {
        this._memberLinksService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      }

    })

  }

  openMemberBackgroundDialog (entity) {

    let data: MemberBackgroundData = new MemberBackgroundData();

    if (entity) {
      data = entity;
    }

    data.member_id = this.data.id
    data.member_name = this.data.name

    let dialogRef = this.dialog.open(MemberBackgroundDialogComponent, {
      width: '600px',
      height: '340px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];

      const data = this._memberBackgroundService.createEntity(formData.getRawValue())

      console.log(JSON.stringify(data))

      if (action === "add") {
        this._memberBackgroundService.insert(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      } else if (action === "edit") {
        this._memberBackgroundService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      }

    })

  }

  openMemberTpiccvDialog (entity) {

    let data: MemberTpiccvData = new MemberTpiccvData();

    if (entity) {
      data = entity;
    }

    data.member_id = this.data.id
    data.member_name = this.data.name

    let dialogRef = this.dialog.open(MemberTpiccvDialogComponent, {
      width: '600px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];

      const data = this._memberTpiccvService.createEntity(formData.getRawValue())
      console.log(JSON.stringify(data))

      if (action === "add") {
        this._memberTpiccvService.insert(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro")
          })
      } else if (action === "edit") {
        this._memberTpiccvService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro")
          })
      }

    })

  }

  goToMemberLink (url: string) {
    url = url.replace("https://", "")
    window.open("https://" + url, "_blank");
  }

  openSubcategoryHistoryDialog (entity) {

    let data: SubcategoryHistory = new SubcategoryHistory();

    if (entity) {
      data = entity;
    }

    data.member_id = this.data.id
    data.member_name = this.data.name

    let dialogRef = this.dialog.open(MemberSubcategoryDialogComponent, {
      width: '400px',
      height: '290px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];

      const data = this._subcategoryHistoryService.createSubcategoryHistory(formData.getRawValue())

      console.log(JSON.stringify(data))

      if (action === "add") {
        this._subcategoryHistoryService.insert(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      } else if (action === "edit") {
        this._subcategoryHistoryService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      }

    })

  }

  deleteSubcategoryHistory (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "Excluir esta categoria?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._subcategoryHistoryService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete category history error: " + error.message)}
          )
      }
    })
  }

  deleteAnnotation (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "Excluir esta anotação?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._annotationService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete annotation error: " + error.message)}
          )
      }
    })
  }

  deleteMemberLink (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "Excluir este Link?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._memberLinksService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete member link: " + error.message)}
          )
      }
    })
  }

  deleteMemberBackground (element) {
    // console.log(element)
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.text + "<br><br>Excluir esta formação?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._memberBackgroundService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete member background: " + error.message)}
          )
      }
    })
  }

  deleteMemberTpiccv (element) {
    // console.log(element)
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.text + "<br><br>Excluir esta anotação?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._memberTpiccvService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete member tpi-ccv: " + error.message)}
          )
      }
    })
  }

  getAddressByPostalCode (code) {

    this._cepService.getCepInformation(code)
      .subscribe((result) => {
        this.memberForm.controls.postalCode.setValue(result.cep);
        this.memberForm.controls.address.setValue(result.logradouro);
        this.memberForm.controls.district.setValue(result.bairro);
        this.memberForm.controls.city.setValue(result.localidade);
        this.memberForm.controls.state.setValue(result.uf);
        this.memberForm.controls.country.setValue('Brasil');
      })

  }


  //////////////////////////////////////////////////////
  // DOCUMENTS /////////////////////////////////////////
  //////////////////////////////////////////////////////

  loadFolders () {
    this._folderService.select()
      .subscribe((result) => {
        let folders: any = []

        result.forEach((item) => {
          folders.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name
          })
        })
        this._documentService.getDocumentsByMember(this.data.id, folders)
      })
  }

  openDocumentDialog (entity) {

    let data: Document = new Document();

    if (entity) {
      data = entity;
    }

    let dialogRef = this.dialog.open(MemberDocumentDialogComponent, {
      width: '800px',
      height: '500px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const form: FormGroup = response[ 1 ];
      const folder: any = response[ 2 ];
      const file: any = response[ 3 ];

      const formData = form.getRawValue()

      /*
      console.log("action: " + action)
      console.log("--------------------------------------")
      console.log("formData: " + JSON.stringify(formData))
      console.log("--------------------------------------")
      console.log("folder: " + JSON.stringify(folder))
      console.log("--------------------------------------")
      console.log("file: " + file.name)
      console.log("--------------------------------------")
      */

      if (action === 'add') {

        this.addDocument(file, formData.folder_id)

      } else if (action === 'edit') {

        this.waiting = this._spinnerService.show();

        const editedDoc = {
          'date': formData.date,
          'approved': formData.approved,
          'filename': formData.filename,
          'folder_id': formData.folder_id
        }

        console.log("editedDoc: " + JSON.stringify(editedDoc))
        console.log("entity.id: " + entity.id)

        this.db.collection('sbccv_documents').doc(entity.id).set(editedDoc, {'merge': true})
          .then(() => {
            console.log("document updated")
          })
          .catch((err) => {
            console.log("erro upadate document: " + err.message)
          })
          .finally(() => {
            this.waiting.close()
          })

      }

    })
  }

  addDocument (file: any, folder_id: string) {

    this.waiting = this._spinnerService.show();

    const finename = file.name
    const member_id = this.data.id

    console.log("uploadDocument item: " + finename)

    const fsRef: AngularFireStorageReference = this.fs.ref("documents/" + member_id + "/" + finename);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateAddedDocument(finename, url, folder_id)
        });
      }))
      .subscribe();

  }

  updateAddedDocument (finename: any, url: any, folder_id: string) {
    let doc: Document = new Document();

    doc.approved = true; // por default - não faz sentido subir manualmente um doc errado!!
    doc.proofOfVaccine = false;
    doc.date = new Date();
    doc.filename = finename;
    doc.member_id = this.data.id;
    doc.member_name = this.data.name;
    doc.url = url;
    doc.folder_id = folder_id;

    this.db.collection('sbccv_documents').add(Object.assign({}, doc))
      .then(() => {
        console.log("document add")
      })
      .catch((err) => {
        console.log("erro upadate document: " + JSON.stringify(err))
      })
      .finally(() => {
        this.waiting.close()
      })

  }

  deleteDocument (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.filename + "<br><br>Excluir este documento?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        // console.log("doc id: " + element.id)
        // console.log("doc url: " + element.url)

        this._documentService.delete(element.id)
          .then(
            () => {
              var storage = this.fs.storage;
              var storageRef = storage.refFromURL(element.url);
              storageRef.delete()
                .then(() => {
                  this.snackBar.openSnackBar("Sucesso!", '', 'success')
                })
                .catch(
                  (error) => {console.log("delete document storage error: " + error.message)}
                )
            }
          )
          .catch(
            (error) => {console.log("delete document error: " + error.message)}
          )
      }
    })
  }

  //////////////////////////////////////////////////////
  // ANUIDADES /////////////////////////////////////////
  //////////////////////////////////////////////////////


  async refresAnnuities () {
    console.log('refresAnnuities')
    let waiting = this._spinnerService.show()

    this.getMemberAllAnnuitiesAdmin(this.data.id)
      .then(() => {
        waiting.close()
      })
      .catch(() => {
        console.log('reresh error')
      })

  }

  async getMemberAllAnnuitiesAdmin (member_id) {
    try {
      const dadosDaFuncao = await this._memberService.getMemberAllAnnuitiesAdmin(member_id);
      // console.log('getMemberAllAnnuitiesAdmin:', JSON.stringify(dadosDaFuncao));
      dadosDaFuncao.payedAnnuities.forEach((item) => {

        if (item.order) {
          item.order.datePayed = null;
          if (item.order.payment_date && typeof item.order.payment_date === 'string') {
            // console.log(item.order.payment_date);
            item.order.datePayed = new Date(item.order.payment_date.replace(/-/g, '\/'));
            //console.log(item.order.datePayed )
          }
        }

      })

      // console.log('dadosDaFuncao.payedAnnuities:', JSON.stringify(dadosDaFuncao.payedAnnuities));
      this.annuitesDataSource = new MatTableDataSource(dadosDaFuncao.payedAnnuities);

      this.totalDebit = dadosDaFuncao.totalDebit
      this.totalPlots = dadosDaFuncao.totalPlots
      this.isAnnuityFree = dadosDaFuncao.isAnnuityFree
      this.calcFinish = true;

    } catch (error) {
      console.error("Erro ao chamar Firebase Function:", error);
    }
  }

  openPaymentDialog (entity) {

    let dialogRef = this.dialog.open(MemberPaymentDialogComponent, {
      width: '600px',
      height: '490px',
      panelClass: 'custom-dialog-container',
      data: entity
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      this.waiting = this._spinnerService.show();

      const formData: FormGroup = response[ 0 ];
      const data = formData.getRawValue()

      const order = new Ordered()
      order.Tid = data.Tid;
      order.authorizationCode = ''
      order.category_id = data.category_id;
      order.category_name = data.category_name
      order.date = data.date;
      order.discount = data.discount;
      order.member_cellPhone = this.data.cellPhone
      order.member_cpf = this.data.cpf
      order.member_debit = this.data.balance
      order.member_email = this.data.email
      order.member_id = this.data.id
      order.member_name = this.data.name
      order.origin = data.origin
      order.cash_operator = this._authService.getIdLogged()
      order.paymentId = data.Tid;
      order.payment_date = data.date
      order.payment_type = data.payment_type
      order.product_id = data.product_id
      order.product_name = data.product_name
      order.returnCode = "00"
      order.type = data.payment_type
      order.tax = data.tax
      order.total = data.total
      order.total_minus_tax = data.total_minus_tax
      order.value = data.value

      //console.log(JSON.stringify(order))

      this._orderedService.insert(order)
        .then(() => {
          this.waiting.close()
        })
        .catch((err) => {
          console.log('Erro')
          this.waiting.close()
        })

    })

  }

  openEditPaymentDialog (element: any) {
    // console.log("element:  " + JSON.stringify(element));
    let dialogRef = this.dialog.open(MemberEditPaymentDialogComponent, {
      width: '600px',
      height: '350px',
      panelClass: 'custom-dialog-container',
      data: element
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];

        if (actionType == 'ok') {

          const data = form.getRawValue();

          const orderId = data.id;
          const updateData = {
            rawValue: data.rawValue,
            discount: data.discount,
            value: data.value,
            total: data.total,
            total_minus_tax: data.total_minus_tax
          }

          console.log("orderId: " + orderId);
          console.log("updateData: " + JSON.stringify(updateData))

          this._orderedService.updateMemmberOrder(orderId, updateData)
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err) => {
              console.log("erro ao atualizar member order")
              this.snackBar.openSnackBar("Erro ao   atualizar", '', 'error')
            })
        }

      })

  }

  checkNextAnnuity (member_id: string) {
    this._annuityService.checkNextAnnuity(member_id)
      .subscribe((result) => {
        if (!result.empty) {
          result.forEach((item: any) => {

            const dt = item.data().date

            this.nextAnnuity = {
              'date': dt.toDate(),
              'product_name': item.data().product_name,
              'member_name': item.data().member_name,
              'category_name': item.data().category_name,
              'origin': item.data().origin,
              'type': item.data().payment_type,
              'value': item.data().value,
              'total': item.data().total
            }

            // console.log(JSON.stringify(this.nextAnnuity))
          })
        }
      })
  }

  //////////////////////////////////////////////////////
  // INSCRIÇÕES /////////////////////////////////////////
  //////////////////////////////////////////////////////

  async gerarRecibo (order) {

    const wait = this._spinnerService.show();
    const dadosFuncao = await this._calableMemberService.requestReceipt(order.id)
    console.log('dadosFuncao ok' + dadosFuncao)
    wait.close();

  }

  async _gerarRecibo (order) {
    //console.log("order.id: " + order.id)

    this._calableMemberService.requestReceipt(order.id)
      .then((result) => {

        console.log(JSON.stringify(result))

        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch(() => {
        console.log("requestReceipt error.")
      })
  }


  //////////////////////////////////////////////////////
  // CERTIFICADOS //////////////////////////////////////
  //////////////////////////////////////////////////////

  loadEnrollments () {
    this._enrolmentService.selectByMember(this.data.id)
      .subscribe((enrollments) => {
        let arrayEnrollments: any[] = []

        enrollments.forEach((enrollment) => {
          arrayEnrollments.push({
            'enrollID': enrollment.payload.doc.id,
            'member_id': enrollment.payload.doc.data().member_id,
            'event_name': enrollment.payload.doc.data().event_name,
            'day_date': enrollment.payload.doc.data().day_date,
            'activity_name': enrollment.payload.doc.data().activity_name,
            'topic_name': enrollment.payload.doc.data().topic_name,
            'certificate_url': enrollment.payload.doc.data().certificate_url,
            'type': enrollment.payload.doc.data().type,
          })
        })
        this.enrolmentDataSource = new MatTableDataSource(arrayEnrollments);
      })
  }

  async requestCertificate (element) {

    console.log("element.enrollID: " + element.enrollID);

    const certificado2PDF = this.ff.httpsCallable('certificado2PDF');
    await certificado2PDF({'id': element.enrollID})
      .subscribe(async () => {
        console.log("sucesso!")
      })

  }

  async sendCertByEmail (element: any) {

    this.waiting = this._spinnerService.show();

    let html: string = "";

    html += "<div>"

    html += "<ul>"

    if (element.event_name) {
      html += "<li>"
      html += "<span style='color:darkblue;'>" + element.event_name + "</span>"
      html += "</li>"
    }

    if (element.day_date) {
      html += "<li>"
      html += "<span style='color:rgba(0,0,0,.6);'>" + this.formatDate(new Date(element.day_date.seconds * 1000)) + "</span>"
      html += "</li>"
    }

    if (element.activity_name) {
      html += "<li>"
      html += "<span style='color:rgba(0,0,0,.6);'>" + element.activity_name + "</span>"
      html += "</li>"
    }

    if (element.topic_name) {
      html += "<li>"
      html += "<span style='color:rgba(0,0,0,.6);'>" + element.topic_name + "</span>"
      html += "</li>"
    }

    html += "</ul>"

    html += "<div style='color:blue; padding: 5px 5px 5px 15px;'>"
    html += "<a target='_blank' href='" + element.certificate_url + "'>"
    html += "Clique aqui para baixar."
    html += "</a>"
    html += "</div>"
    html += "</div>"

    const configs = await this._configService.asyncSelect2()
    // console.log("config: " + JSON.stringify(config));

    let title: string = "";
    let header: string = "";
    let text: string = "";
    let logo: string = "";
    let footer: string = "";

    const user = this.data.name;
    const email = this.data.email;

    configs.forEach((config) => {
      // console.log("config: " + JSON.stringify(config));
      // console.log("-----------------------------------");
      switch (config.id) {

        case "UR9yJPX5Or8UIAcvqHX4": // titulo do email
          title = config.plain_text;
          break;

        case "LihBG46lA0iIhGEmqDfB": // texto do email
          text = config.html_text;
          break;

        case "UR9yJPX5Or8UIAcvqHX4": //titulo email
          header = config.plain_text
          break;

        case "iYP6k0t2ZCxWuSqUuNae": //logo
          logo = "<img style='width:200px;' src='" + config.plain_text + "'>";
          break;

        case "ZCAG0fxGoCcVuOZ52Wke":// footer
          footer = "<img style='width:150px;' src='" + config.plain_text + "'>"
          break;

      }
    });

    let emailBody: any = {};
    emailBody = "<div style = 'margin: 20px; padding: 20px; background-color: white;'>" + text
      .replace("{logo}", logo)
      .replace("{header}", header)
      .replace("{user}", user)
      .replace("{body}", html)
      .replace("{footer}", footer) + "</div>"

    // console.log("send_email_certified acionado ----------")
    console.log("title: " + JSON.stringify(title));
    console.log("emailBody: " + JSON.stringify(emailBody));
    console.log("email: " + JSON.stringify(email));
    //
    this.send_email_certified(title, emailBody, email);

    /*
    this._configService.select()
      .pipe(take(1))
      .subscribe((result) => {

        let title: string = "";
        let header: string = "";
        let text: string = "";
        let logo: string = "";
        let footer: string = "";

        const user = this.data.name;
        const email = this.data.email;

        result.forEach((e) => {
          switch (e.payload.doc.id) {

            case "UR9yJPX5Or8UIAcvqHX4": // titulo do email
              title = e.payload.doc.data().plain_text;
              break;

            case "LihBG46lA0iIhGEmqDfB": // texto do email
              text = e.payload.doc.data().html_text;
              break;

            case "UR9yJPX5Or8UIAcvqHX4": //titulo email
              header = e.payload.doc.data().plain_text
              break;

            case "iYP6k0t2ZCxWuSqUuNae": //logo
              logo = "<img style='width:200px;' src='" + e.payload.doc.data().plain_text + "'>";
              break;

            case "ZCAG0fxGoCcVuOZ52Wke":// footer
              footer = "<img style='width:150px;' src='" + e.payload.doc.data().plain_text + "'>"
              break;

          }

        })

        //LihBG46lA0iIhGEmqDfB

        let emailBody: any = {};
        emailBody = "<div style = 'margin: 20px; padding: 20px; background-color: white;'>" + text
          .replace("{logo}", logo)
          .replace("{header}", header)
          .replace("{user}", user)
          .replace("{body}", html)
          .replace("{footer}", footer) + "</div>"

        console.log("send_email_certified acionado ----------")
        this.send_email_certified(title, emailBody, email);

      })
        */

  }

  send_email_certified (title: string, body: string, email: string) {

    const data = {
      html: body,
      subject: title,
      to: email,
      from: 'sbccv.cientifico@gmail.com',
      bcc: 'sbccv.cientifico@gmail.com'
    }

    //console.log('data: ' + JSON.stringify(data))

    this._emailService.sendStandardEmail(data)
      .then((result) => {
        this.waiting.close();
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err: any) => {
        console.log("erro ao enviar email: " + (err?.message || err));
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })

  }

  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  deleteEnrollment (element) {
    // console.log("deleteEnrollment: " + element.enrollID)
    this._enrolmentService.remove(element.enrollID)
      .then(() => {
        console.log("removed: " + element.enrollID)
      })
      .catch((err) => {
        console.log("erro: " + err.message)
      })

  }

  _changeOrderDate (element) {
    // console.log(JSON.stringify(element))
    const order_id = element.id;
    const order_date: any = element.order_date;

    console.log(order_id);
    console.log(order_date.toDate());

  }

  changeOrderDate (element) {

    const order_id = element.id;
    const order_date: any = element.order_date.toDate();

    let dialogRef = this.dialog.open(MemberOrderDateDialogComponent, {
      width: '300px',
      height: '210px',
      panelClass: 'custom-dialog-container',
      data: {'order_id': order_id, 'order_date': order_date}
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const form: FormGroup = response[ 1 ];
      const formData = form.getRawValue()

      if (action == 'ok') {

        const id = formData.order_id;
        const date = formData.order_date

        console.log(id);
        console.log(date);

        this._orderedService.updateOrder(id, {'date': date})
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err: any) => {
            console.log(err.message)
            this.snackBar.openSnackBar("Erro!", '', 'error');
          })
      }




    })
  }

}
